import React from 'react';
import { clamp } from '../helpers';
import { ChainableNumberInput } from './chainable-number-input';
export const MinutesInput = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { value, onChange, onBlur, ...rest } = props;
    const handleBlur = (event)=>{
        onBlur?.(event);
        if (value) {
            onChange?.(clamp(parseInt(value, 10), 0, 59).toString().padStart(2, '0'));
        }
    };
    return /*#__PURE__*/ React.createElement(ChainableNumberInput, {
        ref: ref,
        min: 0,
        max: 59,
        value: value,
        onBlur: handleBlur,
        onChange: onChange,
        "data-hook": "minutes",
        ...rest
    });
});
MinutesInput.displayName = 'MinutesInput';

//# sourceMappingURL=minutes-input.js.map